"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var samOrderApi = _interopRequireWildcard(require("@/api/samOrderApi"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _SamOrderDetail = _interopRequireDefault(require("./components/SamOrderDetail.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SamOrderList',
  components: {
    SamOrderDetail: _SamOrderDetail.default
  },
  data: function data() {
    return {
      constants: this.$constants,
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0],
        orderNo: '',
        outOrderSn: '',
        jdOrderSn: '',
        childOrderSn: '',
        status: '',
        childOrderStatus: '',
        aftersaleStatus: ''
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: false,
      exportLoading: false,
      showAfterSaleViewBtn: false,
      orderStatusOptions: [],
      subOrderStatusOptions: [],
      aftersaleStatusOptions: [{
        label: '全部',
        value: ''
      }, {
        label: '无售后',
        value: 0
      }, {
        label: '有售后',
        value: 1
      }]
    };
  },
  mounted: function mounted() {
    this.initAfterSaleViewPermission();
    this.loadStatusOptions();
    this.handlerGetListData();
  },
  methods: {
    initAfterSaleViewPermission: function initAfterSaleViewPermission() {
      try {
        var javaInfo = JSON.parse(_jsCookie.default.get('JavaInfo') || '{}');
        this.showAfterSaleViewBtn = Number(javaInfo.type) === 1;
      } catch (e) {
        this.showAfterSaleViewBtn = false;
      }
    },
    loadStatusOptions: function loadStatusOptions() {
      var _this = this;
      samOrderApi.getOrderStatusGrouped().then(function () {
        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var data = res;
        var mainList = data.main.mainOrderStatus || [];
        var childList = data.child.childOrderStatus || [];
        _this.orderStatusOptions = mainList.map(function (it) {
          return {
            label: it.desc,
            value: it.code
          };
        });
        _this.subOrderStatusOptions = childList.map(function (it) {
          return {
            label: it.desc,
            value: it.code
          };
        });
      }).catch(function () {
        _this.orderStatusOptions = [];
        _this.subOrderStatusOptions = [];
      });
    },
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handlerGetListData();
    },
    handleReset: function handleReset() {
      this.listPram = {
        page: 1,
        limit: this.$constants.page.limit[0],
        orderNo: '',
        outOrderSn: '',
        jdOrderSn: '',
        childOrderSn: '',
        status: '',
        childOrderStatus: '',
        aftersaleStatus: ''
      };
      this.handlerGetListData();
    },
    handlerGetListData: function handlerGetListData() {
      var _this2 = this;
      this.listLoading = true;
      samOrderApi.getSamOrderList(this.listPram).then(function () {
        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var data = res.data || res;
        var payload = data && data.data ? data.data : data;
        var list = Array.isArray(payload && payload.list) ? payload.list : [];
        var total = payload && payload.total || 0;
        _this2.listData = {
          list: list,
          total: total
        };
      }).catch(function () {
        _this2.listData = {
          list: [],
          total: 0
        };
      }).finally(function () {
        _this2.listLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData();
    },
    handleExport: function handleExport() {
      var _this3 = this;
      this.exportLoading = true;
      samOrderApi.exportSamOrder(this.listPram).then(function () {
        _this3.$message.success('导出任务已提交');
      }).catch(function () {
        _this3.$message.error('导出失败');
      }).finally(function () {
        _this3.exportLoading = false;
      });
    },
    openDetail: function openDetail(row) {
      if (!row) return;
      var orderNo = row.orderNo || row.outOrderSn;
      if (!orderNo) {
        this.$message.warning('订单号缺失');
        return;
      }
      this.$refs.samOrderDetailRef && this.$refs.samOrderDetailRef.open(orderNo);
    },
    openAfterSaleDetail: function openAfterSaleDetail(row) {
      if (!row) return;
      var orderNo = row.orderNo;
      if (!orderNo) {
        this.$message.warning('订单号缺失');
        return;
      }
      this.$router.push({
        path: '/order/aftersale',
        query: {
          orderNo: orderNo
        }
      });
    },
    hasAftersale: function hasAftersale(row) {
      if (!row) return false;
      return Number(row.aftersaleStatus) !== 0;
    }
  }
};